import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import config from '../../../config';
import {
  mapProjectLookup,
  ProjectLookup,
  ProjectLookupDto,
} from '../models/new-demand.models';

@Injectable({ providedIn: 'root' })
export class NewDemandService {
  private readonly http = inject(HttpClient);

  getProject(cmdbId: string): Observable<ProjectLookup> {
    const endpoint = new URL(config.API_GATEWAY_ENDPOINT);
    const baseUrl = endpoint.href.endsWith('/')
      ? endpoint.href
      : `${endpoint.href}/`;
    const url = new URL(`project/${encodeURIComponent(cmdbId)}`, baseUrl);
    return this.http
      .get<ProjectLookupDto>(url.toString())
      .pipe(map(mapProjectLookup));
  }
}
